import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEng from "./en/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEng
      }
    },
    debug: false,
    lng: "en",
    fallbackLng: "en",
    keySeparator: ".",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
